export const homeServicesMock = [
  {
    id: 1,
    icon: 'icon-split',
    translationKey: 'splitPayment',
    className: 'service-split-payment',
  },
  {
    id: 2,
    icon: 'icon-chat',
    translationKey: 'customerService',
    className: 'service-customer-service',
  },
  {
    id: 3,
    icon: 'icon-oeko-tex',
    translationKey: 'oekoTex',
    className: 'service-oeko-tex',
  },
  {
    id: 4,
    icon: 'icon-made-in-europe',
    translationKey: 'madeInEurope',
    className: 'service-made-in-europe',
  },
  {
    id: 5,
    icon: 'icon-warranty',
    translationKey: 'warranty',
    className: 'service-warranty',
  },
];

export const headerServicesMock = [
  {
    id: 1,
    icon: 'icon-split',
    translationKey: 'splitPayment',
    className: 'service-split-payment',
  },
  {
    id: 2,
    icon: 'icon-oeko-tex',
    translationKey: 'oekoTex',
    className: 'service-oeko-tex',
  },
  {
    id: 3,
    icon: 'icon-made-in-europe',
    translationKey: 'madeInEurope',
    className: 'service-made-in-europe',
  },
  {
    id: 4,
    icon: 'icon-warranty',
    translationKey: 'warranty',
    className: 'service-warranty',
  },
];

export const categoryServicesMock = [
  {
    id: 1,
    icon: 'icon-split',
    translationKey: 'splitPayment',
    className: 'service-split-payment',
  },
  {
    id: 2,
    icon: 'icon-chat',
    translationKey: 'customerService',
    className: 'service-customer-service',
  },
  {
    id: 3,
    icon: 'icon-oeko-tex',
    translationKey: 'oekoTex',
    className: 'service-oeko-tex',
  },
  {
    id: 4,
    icon: 'icon-made-in-europe',
    translationKey: 'madeInEurope',
    className: 'service-made-in-europe',
  },
  {
    id: 5,
    icon: 'icon-warranty',
    translationKey: 'warranty',
    className: 'service-warranty',
  },
];

export const productServicesMock = [
  {
    id: 1,
    icon: 'icon-split',
    translationKey: 'splitPayment',
    className: 'service-split-payment',
  },
  {
    id: 2,
    icon: 'icon-chat',
    translationKey: 'customerService',
    className: 'service-customer-service',
  },
  {
    id: 3,
    icon: 'icon-all',
    translationKey: 'rewardPoints',
    className: 'service-reward-points',
  },
];
